export const meterPerSecondToKmPerHour = (wind: number) => {
  return (wind * 3.6).toFixed(2);
};

export const convertMinutesToHour = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  const hoursPart = hours > 0 ? `${hours}h` : "";
  const minsPart = mins > 0 ? `${mins}m` : "";

  if (hoursPart && minsPart) {
    return `${hoursPart}:${minsPart}`;
  } else if (hoursPart) {
    return hoursPart;
  } else {
    return minsPart;
  }
};
